import type { BffApiClient } from "@/app/api-client"
import type { InferRequestType } from "hono"

type QueryInputRequest =
  BffApiClient["api"]["profile"][":address"]["activity"]["$post"]

export type QueryInput = {
  param: InferRequestType<QueryInputRequest>["param"]
  blockchains: InferRequestType<QueryInputRequest>["json"]["blockchains"]
}

export const getProfileActivityQueryParams = (
  apiClient: BffApiClient,
  queryInput: QueryInput,
) => ({
  queryKey: ["profile", "activity", queryInput],
  queryFn: async ({ pageParam }: { pageParam?: string }) => {
    const response = await apiClient.api.profile[":address"].activity.$post({
      json: {
        cursor: pageParam,
        blockchains: queryInput.blockchains,
      },
      param: queryInput.param,
    })

    if (!response.ok) throw await response.json()

    return response.json()
  },
  initialPageParam: undefined,
  getNextPageParam: (lastPage: { cursor?: string }) => {
    return lastPage.cursor
  },
})

type QueryFn = ReturnType<typeof getProfileActivityQueryParams>["queryFn"]

export type QueryResponse = Awaited<ReturnType<QueryFn>>
